import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { InputAdornment, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { Formik, Form } from 'formik';
import debounce from 'lodash/debounce';
import styles from './styles'

const SearchForm = ({ classes, isDynamicSearch, search }) => {
  const debouncedOnChange = debounce((value) => {
    search(value);
  }, 300);

  return (
    <Formik
      initialValues={{ searchValue: '' }}
      onSubmit={(values, { isSubmitting }) => {
        if (isSubmitting) return;
        search(values.searchValue);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form autoComplete="off" className={classes.fullWidth}>
          <TextField
            type="text"
            name="searchValue"
            variant="outlined"
            placeholder="Search"
            value={values.searchValue}
            onChange={(e) => {
              const input = e.target.value;
              setFieldValue('searchValue', input);
              isDynamicSearch && debouncedOnChange(input, setFieldValue);
            }}
            // className={classes.search}
            style={{ width: '100%' }}
            inputProps={{ 'aria-label': 'Search' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                </InputAdornment>
              ),
            }}
          />
        </Form>
      )}
    </Formik>
  )
}

SearchForm.propTypes = {
  classes: propTypes.object,
  isDynamicSearch: propTypes.bool,
  search: propTypes.func.isRequired,
}

export default withStyles(styles)(SearchForm);